import { formatDateWithCurrentTime } from '../../util/standardizedDate'

export const formattedDate = (date: string) => {
  return formatDateWithCurrentTime(date)
}
